module.exports = __webpack_public_path__ + "static/media/microservice.c98a4dde.svg";